import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';

@Injectable()
export class TableLookupService {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;

  public getLookup(_table: string): Promise<any> {

    let url = `${this.BASE_URL}${_table}?&%24count=true`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => response);
  }
}